import { render, staticRenderFns } from "./help-center.vue?vue&type=template&id=24436cc1&"
import script from "./help-center.vue?vue&type=script&lang=js&"
export * from "./help-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports